const initialState = {
    permissions: [],
    enterpriseRoles: [],
    submitted: false,
    message: undefined,
    form: {}
};

function usersReducer(state = initialState, action = {}) {
    switch (action.type) {
        case 'USER_ADD_REQUEST':
            return {
                ...initialState,
                user: action.user,
                submitted: true
            };

        case 'USER_ADD_SUCCESS':
            return {
                ...initialState,
                success: true
            };

        case 'USER_ADD_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'USER_ADD_FORM_VALIDATION':
            return {
                ...state,
                submitted: false,
                form: {
                    ...state.form,
                    ...action.form
                }
            };

        case 'GET_ENTERPRISE_PERMISSIONS_SUCCESS':
            return {
                ...state,
                permissions: action.permissions,
                submitted: false,
                success: true
            };

        case 'GET_ENTERPRISE_ROLES_SUCCESS':
            return {
                ...state,
                enterpriseRoles: action.enterpriseRoles,
                submitted: false,
                success: true
            };

        case 'GRAPH_DATA_CORE_REQUEST':
            return {
                ...state,
                json1: action.json1,
                json2: action.json2,
                json3: action.json3,
                json4: action.json4,
                json5: action.json5,
                json6: action.json6,
                json7: action.json7,
                submitted: true,
                form: {
                    ...state.form,
                    ...action.form
                }
            };

        case 'GRAPH_DATA_CORE_SUCCESS':
            return {
                ...state,
                data: action.data,
                submitted: false,
                success: true
            };

        case 'GRAPH_DATA_CORE_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        case 'GRAPH_DATA_RADIO_REQUEST':
            return {
                ...state,
                json1: action.json1,
                json2: action.json2,
                json3: action.json3,
                json4: action.json4,
                json5: action.json5,
                json6: action.json6,
                submitted: true,
                form: {
                    ...state.form,
                    ...action.form
                }
            };
        case 'SLO_GRAPH_DATA_RADIO_REQUEST':
            return {
                ...state,
                json1: action.json1,
                json2: action.json2,
                json3: action.json3,
                json4: action.json4,
                json5: action.json5,
                json6: action.json6,
                json7: action.json7,
                json8: action.json8,
                json9: action.json9,
                json10: action.json10,
                json11: action.json11,
                json12: action.json12,
                json13: action.json13,
                json14: action.json14,
                json15: action.json15,
                json16: action.json16,
                submitted: true,
                form: {
                    ...state.form,
                    ...action.form
                }
            };

        case 'GRAPH_DATA_RADIO_SUCCESS':
            return {
                ...state,
                data: action.data,
                submitted: false,
                success: true
            };
        case 'SLO_GRAPH_DATA_RADIO_SUCCESS':
            return {
                ...state,
                data: action.data,
                submitted: false,
                success: true
            };

        case 'GRAPH_DATA_RADIO_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };
        case 'SLO_GRAPH_DATA_RADIO_API_ERROR':
            return {
                ...state,
                submitted: false,
                message: action.message,
                form: action.form
            };

        default:
            return state;
    }
}

export default usersReducer;
